/**
 * Joins one label per line of an array into a single header field.
 *
 * Config shape:
 * {
 *     logicType: 'calcFields',
 *     operationType: 'header.joinLines',
 *     array: 'legs',
 *     fields: ['accountNumber', 'signName'],   // parts of each line's label
 *     fieldSeparator: ' ',                     // between parts, default ' '
 *     separator: ' + ',                        // between lines, default ', '
 *     targetField: 'legsText'
 * }
 *
 * header.merge joins fields of the document itself; this is the same thing
 * across its lines, for a list or a summary that should show what the lines add
 * up to without opening the record.
 *
 * Empty parts are skipped rather than printed as gaps, and a line with no parts
 * at all is left out, so a half-filled line reads as what it has. Unlike
 * header.merge the target is always written — an array that empties must clear
 * the summary, not leave the last one standing.
 */
const headerJoinLines = (data, operation) => {
    const { array, fields, fieldSeparator = ' ', separator = ', ', targetField } = operation
    if (!array || !Array.isArray(fields) || !targetField) return data

    const lines = Array.isArray(data?.[array]) ? data[array] : []
    const labels = lines
        .map(line => fields
            .map(f => line?.[f])
            .filter(v => v !== undefined && v !== null && v !== '')
            .join(fieldSeparator))
        .filter(Boolean)

    return { ...data, [targetField]: labels.join(separator) }
}

export default headerJoinLines
